export const SET_HISTORY = 'routerHistory-set';

export const setHistory = (routerName, history) => ({
    type: SET_HISTORY,
    payload: { [routerName]: history },
});
